<div class="grid-container">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Beispieldesign einer Card</mat-card-title>
    </mat-card-header>
    <!--BEISPIEL CARD-->
    <mat-card-content class="wrapperExampleCard">
      <mat-card appearance="outlined" class="card-example">
        <mat-card-header class="header-example">
          <mat-card-title>Card Title</mat-card-title>
          <mat-card-subtitle>Card Subtitle</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="mat-card-content-example">
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet.
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions>
      </mat-card>
      <!--HTML CODE DER KARTE-->
      <div class="card-example__code">
        <figure>
          <pre>
            <code contenteditable spellcheck="false">
              &lt;mat-card></code><code class="card-example__code--header">
                &lt;mat-card-header>
                  &lt;mat-card-title>Card Title&lt;/mat-card-title>
                  &lt;mat-card-subtitle>Card Subtitle&lt;/mat-card-subtitle>
                &lt;/mat-card-header>
              </code><code class="card-example__code--content">
                &lt;mat-card-content></code><code>
                  &lt;p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                    sed diam nonumy eirmod tempor invidunt ut labore
                    et dolore magna aliquyam erat, sed diam voluptua.
                    At vero eos et accusam et justo duo dolores et ea rebum.
                    Stet clita kasd gubergren, no sea takimata sanctus est
                    Lorem ipsum dolor sit amet.
                  &lt;/p>
                <code class="card-example__code--content">&lt;/mat-card-content></code>
              </code><code>
                &lt;mat-card-actions>
                  &lt;button mat-button>LIKE&lt;/button>
                  &lt;button mat-button>SHARE&lt;/button>
                &lt;/mat-card-actions>
              &lt;/mat-card>
            </code>
          </pre>
        </figure>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!--TYPO-->
<div class="grid-container">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Aufbau Typografie</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-accordion multi="true">
        @for (dataset of headlines; track $index) {
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <div>
                <span [class]="dataset.headline_cssClass1">{{
                  dataset.headline_name
                }}</span>
                &nbsp; | &nbsp;
                <span class="typoBox__cssClasses"
                  >{{ dataset.headline_cssClass1 }} ,
                  {{ dataset.headline_cssClass2 }}</span
                >
              </div>
            </mat-expansion-panel-header>
            <div class="typoBox__cssClassesProperties">
              {{ dataset.headline_cssProperties }}
            </div>
            <mat-divider [inset]="true"></mat-divider>
            <div [class]="dataset.headline_cssClass1">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet.
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</div>

<!--FARBEN-->
<div class="grid-container">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Farben</mat-card-title>
    </mat-card-header>
    <!--HAUPTFARBEN-->
    <mat-card-content>
      <mat-accordion multi="true">
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header> Hauptfarben </mat-expansion-panel-header>
          <div class="color-examples">
            @for (singleColor of MainColorsWettermanufaktur; track $index) {
              <div class="color-examples__single">
                <div
                  class="color-box"
                  [style.background-color]="
                    'rgb(' + singleColor.rgb_code + ')'
                  "></div>
                <div class="color-examples__text">
                  {{ singleColor.hex_code }} <br />
                  {{ singleColor.rgb_code }}
                </div>
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>

    <!--FARBEN WINTERINDIKATOREN-->
    <div class="mat-subtitle-1 marginForSubheading">
      Winterindikatoren (Belagszustände)
    </div>
    <mat-card-content>
      <mat-accordion multi="true">
        @for (singleCategory of ColorsWinter | getKeysOfObject; track $index) {
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ singleCategory }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="color-examples">
              @for (
                singleDataOfCategory of ColorsWinter[singleCategory];
                track $index
              ) {
                <div class="color-examples__single">
                  <div
                    class="color-box"
                    [style.background-color]="
                      'rgb(' + singleDataOfCategory.rgb_code + ')'
                    "></div>
                  <div class="color-examples__text">
                    {{ singleDataOfCategory.hex_code }} <br />
                    {{ singleDataOfCategory.rgb_code }} <br />
                    <!--<hr class="divider">-->
                    <mat-divider [inset]="true"></mat-divider>
                    <span class="mat-body-strong">{{
                      singleDataOfCategory.variable_name
                    }}</span>
                    <br />
                    = {{ singleDataOfCategory.definition }}
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-card-content>

    <!--FARBEN SOMMERIDENTIKATOREN-->
    <div class="mat-subtitle-1 marginForSubheading">Sommerindikatoren</div>
    <mat-card-content>
      <mat-accordion multi="true">
        @for (singleCategory of ColorsSommer | getKeysOfObject; track $index) {
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ singleCategory }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="color-examples">
              @for (
                singleDataOfCategory of ColorsSommer[singleCategory];
                track $index
              ) {
                <div class="color-examples__single">
                  <div
                    class="color-box"
                    [style.background-color]="
                      'rgb(' + singleDataOfCategory.rgb_code + ')'
                    ">
                    {{ singleDataOfCategory.identicator_number }}
                  </div>
                  <div class="color-examples__text">
                    {{ singleDataOfCategory.hex_code }} <br />
                    {{ singleDataOfCategory.rgb_code }} <br />
                    <mat-divider [inset]="true"></mat-divider>
                    <span class="mat-body-strong">{{
                      singleDataOfCategory.variable_name
                    }}</span>
                    <br />
                    {{ singleDataOfCategory.definition }}
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</div>
